"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PushNotificationService = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _Api = _interopRequireDefault(require("../Api"));
var _excluded = ["token", "fcmToken", "condo"],
  _excluded2 = ["token", "condo"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var PushNotificationService = exports.PushNotificationService = /*#__PURE__*/(0, _createClass2["default"])(function PushNotificationService() {
  (0, _classCallCheck2["default"])(this, PushNotificationService);
});
(0, _defineProperty2["default"])(PushNotificationService, "register", function (_ref) {
  var token = _ref.token,
    fcmToken = _ref.fcmToken,
    condo = _ref.condo,
    params = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return _Api["default"].withAuth(token).post('/notification/register', _objectSpread({
    token: fcmToken,
    condo: condo
  }, params));
});
(0, _defineProperty2["default"])(PushNotificationService, "unregister", function (_ref2) {
  var token = _ref2.token,
    condo = _ref2.condo,
    params = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);
  return _Api["default"].withAuth(token).post('/notification/unregister', _objectSpread({
    condo: condo
  }, params));
});